import { ToastrService } from 'ngx-toastr';

// Function to open a window and check if it was blocked
export function openWindow(url: string, toastr: ToastrService): void {
  const popup = window.open(url, '_blank');
  if (!popup || popup.closed || typeof popup.closed === 'undefined') {
    // Popup was blocked
    toastr.error('La fenêtre pop-up a été bloquée par votre navigateur.', 'Erreur');
  }
}